import { render, staticRenderFns } from "./ProductInfos.vue?vue&type=template&id=27bd0dff&scoped=true&"
import script from "./ProductInfos.vue?vue&type=script&lang=js&"
export * from "./ProductInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfos.vue?vue&type=style&index=0&id=27bd0dff&scoped=true&lang=scss&"
import style1 from "./ProductInfos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd0dff",
  null
  
)

export default component.exports